export enum NotificationPreferencesEnum {
  TIME_OFF_STATUS = "TIME_OFF_STATUS",
  WORKSHEET_STATUS = "WORKSHEET_STATUS",
  VEHICLE_ISSUE_NEW = "VEHICLE_ISSUE_NEW",
  ISSUE_NEW = "ISSUE_NEW",
  QUALIFICATION_EXPIRING = "QUALIFICATION_EXPIRING",
  ITEM_REVIEW = "ITEM_REVIEW",
  VEHICLE_MAINTENANCE_REVIEW = "VEHICLE_MAINTENANCE_REVIEW",
  PURCHASE_ORDER_APPROVED = "PURCHASE_ORDER_APPROVED",
  PURCHASE_ORDER_PRICED_NEEDS_APPROVAL = "PURCHASE_ORDER_PRICED_NEEDS_APPROVAL",
}

export const getNotificationPreferencesLabel = (type: NotificationPreferencesEnum): string => {
  switch (type) {
    case NotificationPreferencesEnum.TIME_OFF_STATUS:
      return "Cambios de estado";
    case NotificationPreferencesEnum.WORKSHEET_STATUS:
      return "Cambios de estado";
    case NotificationPreferencesEnum.VEHICLE_ISSUE_NEW:
      return "Nueva incidencia";
    case NotificationPreferencesEnum.ISSUE_NEW:
      return "Nueva incidencia";
    case NotificationPreferencesEnum.QUALIFICATION_EXPIRING:
      return "Caducidad de formación";
    case NotificationPreferencesEnum.ITEM_REVIEW:
      return "Revisión de artículos";
    case NotificationPreferencesEnum.VEHICLE_MAINTENANCE_REVIEW:
      return "Revisión de mantenimiento";
    case NotificationPreferencesEnum.PURCHASE_ORDER_APPROVED:
      return "Pedido de almacén aprobado";
    case NotificationPreferencesEnum.PURCHASE_ORDER_PRICED_NEEDS_APPROVAL:
      return "Pedido de almacén valorado requiere aprobación";
    default:
      return "-";
  }
};
